import { Grid } from "@mui/material";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";
import { Profile } from "models/profile/Profile";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";

export const ProfileSettings = ({ profile }: { profile: Profile }) => {
  const columns: GridColDef[] = [
    {
      field: "key",
      headerName: "Key",
      valueFormatter: (v) => camelCaseToCapitalizedWords(v),
    },
    {
      field: "value",
      headerName: "Value",
    },
  ];

  return (
    <Grid>
      <DataGridPro
        rows={Object.entries(profile?.settings || {}).map(([key, value], index) => ({
          key,
          value,
        }))}
        density="compact"

        columns={columns}
        getRowId={(row) => row.key}
      />
    </Grid>
  );
};
